import PopupVideos from '../modules/popup-videos';
export default class Videos {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.popupVideosEl = document.querySelector('[data-popup-video]');
        this.popupVideosInstance = null;

        this.popupVideosButtonEl = this.root.querySelectorAll(
            '[button-video-popup]'
        );

        return true;
    }

    init() {
        this.setPopup();
        this.setClick();
    }

    setPopup() {
        if (!this.popupVideosEl) return;
        this.popupVideosInstance = new PopupVideos(this.popupVideosEl);
    }

    setClick() {
        if (!this.popupVideosButtonEl) return;

        this.popupVideosButtonEl.forEach(item => {
            item.addEventListener('click', event => {
                const { currentTarget } = event;
                const posterUrl = currentTarget.getAttribute(
                    'button-video-popup-thumb'
                );
                const videoUrl = currentTarget.getAttribute(
                    'button-video-popup-url'
                );

                this.popupVideosInstance.showPopup();
                this.popupVideosInstance.setPoster(posterUrl);
                this.popupVideosInstance.setVideo(videoUrl);
            });
        });
    }
}

const sections = document.querySelectorAll('[videos]');
const initVideos = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new Videos(el);
    });
};

initVideos(sections);
